/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
function Book() {
  return (
    <main className="com_container p_student_book">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu2_1">
            학생관리
            <span className="bar" />
            <span className="point_txt">교재 지급내역 (홍학생103ㆍ경기고1ㆍ남)</span>
          </h2>
        </section>
        <section className="com_pg_container">
          {/* 수업정보 */}
          <section className="box full">
            <h3 className="box_tit">교재지급 (10)</h3>
            <table className="com_board_list">
              <colgroup>
                <col width="10%" />
                <col width="8%" />
                <col width="8%" />
                <col width="15%" />
                <col width="auto" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
              </colgroup>
              <thead>
                <tr>
                  <th>지급일</th>
                  <th>지급 방법</th>
                  <th>과목</th>
                  <th>교재명</th>
                  <th>지급 사유</th>
                  <th>신청자</th>
                  <th>단가</th>
                  <th>누적</th>
                  <th>이동</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="td_date">2022, 08, 25</td>
                  <td>직접전달</td>
                  <td>국어</td>
                  <td>영어 단단 단어장 (2203)</td>
                  <td>수업에 필요해서 지급합니다.</td>
                  <td>
                    <button className="btn_link">홍길동103</button>
                  </td>
                  <td>67,500</td>
                  <td className="td_point">180</td>
                  <td>
                    <button className="btn_link blue">이동</button>
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td className="td_date">2022, 08, 25</td>
                      <td>택배</td>
                      <td>국어</td>
                      <td>영어 단단 단어장 (2203)</td>
                      <td>수업에 필요해서 지급합니다.</td>
                      <td>
                        <button className="btn_link">홍길동103</button>
                      </td>
                      <td>67,500</td>
                      <td className="td_point">180</td>
                      <td>
                        <button className="btn_link blue">이동</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="com_btn_wrap right">
              <button className="com_btn black xs btn_down_orange">다운로드</button>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}

export default Book;
